import React from 'react'
import PropTypes from 'prop-types'

const SIZE_CLASSES = {
  xs: 'tw:size-4 tw:border-2',
  small: 'tw:size-10 tw:border-2',
  medium: 'tw:size-16 tw:border-4',
  large: 'tw:size-20 tw:border-4'
}

const BASE_CLASSES = 'tw:inline-block tw:animate-spin tw:rounded-full! '
  + 'tw:border-solid tw:border-ds-neutral-lowest tw:border-t-ds-info'

const Spinner = ({ className = '', size = 'medium' }) => (
  <span
    aria-hidden="true"
    className={`${BASE_CLASSES} ${SIZE_CLASSES[size]} ${className}`.trim()}
  />
)

Spinner.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(['xs', 'small', 'medium', 'large'])
}

Spinner.defaultProps = {
  className: '',
  size: 'medium'
}

export default Spinner
